import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=392ac97a&"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports